module.exports = __webpack_public_path__ + "static/media/defaultShippingExample.64e1f795.png";